import _defineProperty from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pick = function pick(attrs, allowed) {
  if (!attrs) {
    return null;
  }

  var h = {};

  for (var key in attrs) {
    var value = attrs[key];

    if (allowed.indexOf(key) > -1 && value !== null) {
      h[key] = value;
    }
  }

  return h;
};

var isEmailLinkType = function isEmailLinkType(type) {
  return type === "email";
};

export default {
  nodes: {
    horizontal_rule: function horizontal_rule() {
      return {
        singleTag: "hr"
      };
    },
    blockquote: function blockquote() {
      return {
        tag: "blockquote"
      };
    },
    bullet_list: function bullet_list() {
      return {
        tag: "ul"
      };
    },
    code_block: function code_block(node) {
      return {
        tag: ["pre", {
          tag: "code",
          attrs: node.attrs
        }]
      };
    },
    hard_break: function hard_break() {
      return {
        singleTag: "br"
      };
    },
    heading: function heading(node) {
      return {
        tag: "h".concat(node.attrs.level)
      };
    },
    image: function image(node) {
      return {
        singleTag: [{
          tag: "img",
          attrs: pick(node.attrs, ["src", "alt", "title"])
        }]
      };
    },
    list_item: function list_item() {
      return {
        tag: "li"
      };
    },
    ordered_list: function ordered_list() {
      return {
        tag: "ol"
      };
    },
    paragraph: function paragraph() {
      return {
        tag: "p"
      };
    }
  },
  marks: {
    bold: function bold() {
      return {
        tag: "b"
      };
    },
    strike: function strike() {
      return {
        tag: "strike"
      };
    },
    underline: function underline() {
      return {
        tag: "u"
      };
    },
    strong: function strong() {
      return {
        tag: "strong"
      };
    },
    code: function code() {
      return {
        tag: "code"
      };
    },
    italic: function italic() {
      return {
        tag: "i"
      };
    },
    link: function link(node) {
      var attrs = _objectSpread({}, node.attrs);

      var _node$attrs$linktype = node.attrs.linktype,
          linktype = _node$attrs$linktype === void 0 ? "url" : _node$attrs$linktype;

      if (isEmailLinkType(linktype)) {
        attrs.href = "mailto:".concat(attrs.href);
      }

      if (attrs.anchor) {
        attrs.href = "".concat(attrs.href, "#").concat(attrs.anchor);
        delete attrs.anchor;
      }

      return {
        tag: [{
          tag: "a",
          attrs: attrs
        }]
      };
    },
    styled: function styled(node) {
      return {
        tag: [{
          tag: "span",
          attrs: node.attrs
        }]
      };
    }
  }
};